const shortDateFormatter = new Intl.DateTimeFormat('en-AU', {
  weekday: 'short',
  day: '2-digit',
  month: '2-digit',
  year: 'numeric'
});

const monthFormatter = new Intl.DateTimeFormat('en-AU', {
  month: 'long',
  year: 'numeric'
});

export function todayString() {
  const now = new Date();
  const offset = now.getTimezoneOffset() * 60000;
  return new Date(now.getTime() - offset).toISOString().slice(0, 10);
}

export function parseDate(dateString) {
  return new Date(`${dateString}T12:00:00`);
}

export function formatDate(dateString) {
  return shortDateFormatter.format(parseDate(dateString));
}

export function isWeekend(dateString) {
  const day = parseDate(dateString).getDay();
  return day === 0 || day === 6;
}

export function monthRange(monthOffset = 0) {
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth() - monthOffset, 1);
  const end = new Date(now.getFullYear(), now.getMonth() - monthOffset + 1, 1);

  return {
    key: `${start.getFullYear()}-${String(start.getMonth() + 1).padStart(2, '0')}`,
    label: monthFormatter.format(start),
    start: localDateString(start),
    end: localDateString(end)
  };
}

function localDateString(date) {
  const offset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() - offset).toISOString().slice(0, 10);
}

export function currency(value) {
  return Number(value || 0).toLocaleString('en-AU', {
    style: 'currency',
    currency: 'AUD'
  });
}